import { useRef, useState } from 'react';

export default function useCheckoutState () {
    const selectedPlanCodeRef = useRef(null);
    const [checkoutOpen, setCheckoutOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedAddOnValues, setSelectedAddOnValues] = useState({});

    function handleChoosePlan (plan, addOnValues = {}) {
        selectedPlanCodeRef.current = plan.code;
        setSelectedPlan(plan);
        setSelectedAddOnValues(addOnValues);
        setCheckoutOpen(true);
    }

    function closeCheckout () {
        setCheckoutOpen(false);
    }

    return { checkoutOpen, selectedPlan, selectedAddOnValues, selectedPlanCodeRef, handleChoosePlan, closeCheckout };
}
